module.exports = __webpack_public_path__ + "static/media/VAG-HandWritten.ec11427d.otf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/VAG-HandWritten.otf
// module id = 790
// module chunks = 0